import './vendor';
import './helpers';
import vars from './helpers';
import './components/social';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import lazyLoading from './modules/lazyLoading';
import lazyBlure from './modules/lazyBlure';

ieFix();
vhFix();
actualYear();

lazyLoading.init();
lazyBlure.init();

function menuBurger() {
	let $btnOpen = $('.js-menu-open');
	let $btnClose = $('.js-menu-close');
	let $menu = $('.menu');

	$($btnOpen).on('click', function () {
		vars.$html.addClass('is-lock-scroll');
		$menu.addClass('is-show');
	});

	$($btnClose).on('click', function () {
		vars.$html.removeClass('is-lock-scroll');
		$menu.removeClass('is-show');
	});
}

menuBurger();
